/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_A_Text_HeaderInputs */



/**
* | output |
* | --- |
* | "Group A Text" |
*
* @param {Compare_Event_Groups_Csv_Group_A_Text_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_a_text_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_A_Text_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_A_Text_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte du groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text der Gruppe A")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo del gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст группы А")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto del grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("A组文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループAテキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह ए पाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto do Grupo A")
	return /** @type {LocalizedString} */ ("Group A Text")
});